import { render, staticRenderFns } from "./IamGroups.vue?vue&type=template&id=393b1e70&scoped=true&"
import script from "./IamGroups.vue?vue&type=script&lang=js&"
export * from "./IamGroups.vue?vue&type=script&lang=js&"
import style0 from "./IamGroups.vue?vue&type=style&index=0&id=393b1e70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393b1e70",
  null
  
)

export default component.exports